/**
 * Ensures the product gallery carousel opens on the intended first slide on mobile.
 * Prestige only programmatically scrolls when the initial index is > 0, so snap-center
 * carousels can settle on the wrong slide at scrollLeft 0.
 */
(function () {
  const alignInitialSlide = (carousel) => {
    if (!carousel?.cells?.length) return;

    const initialIndex = Math.max(
      0,
      carousel.cells.findIndex((cell) => cell.classList.contains('is-initial'))
    );

    carousel.select(initialIndex, { instant: true });
  };

  const initGalleries = () => {
    document.querySelectorAll('scroll-carousel.product-gallery__carousel').forEach((carousel) => {
      if (carousel.dataset.erkalsGalleryAligned === 'true') return;

      alignInitialSlide(carousel);
      carousel.dataset.erkalsGalleryAligned = 'true';
    });
  };

  const boot = () => {
    if (window.customElements.get('scroll-carousel')) {
      initGalleries();
      return;
    }

    window.customElements.whenDefined('scroll-carousel').then(initGalleries);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
